export default __webpack_public_path__ + "static/media/active_projects.c9072ca8.svg";